import { UseFormWatch } from "react-hook-form";

export function useJobApprovalFieldsToHide(
    watch: UseFormWatch<Compleo.IObject>
) {
    const fieldsToHide = ["jobCategory", "customers", "branches"];
    const selectionType = watch("selectionType")?.value;

    if (selectionType === "customers") {
        // Remove customers from the fields to hide
        fieldsToHide.splice(fieldsToHide.indexOf("customers"), 1);
    }
    if (selectionType === "branches") {
        // Remove branches from the fields to hide
        fieldsToHide.splice(fieldsToHide.indexOf("branches"), 1);
    }
    if (selectionType === "jobCategory") {
        // Remove jobCategory from the fields to hide
        fieldsToHide.splice(fieldsToHide.indexOf("jobCategory"), 1);
    }
    console.log("fieldsToHide", fieldsToHide);
    console.log("fieldsToHide selectionType", selectionType);
    return fieldsToHide;
}
